import { useCallback, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import PageLoader from '@/components/common/page-loader';
import BottomNav from '@/components/layout/bottom-nav';
import TopNav from '@/components/layout/top-nav';
import { Sidepanel } from '@/components/sidepanel';
import { Sheet } from '@/components/ui/sheet';
import useRoleAccess from '@/hooks/use-role-access';
import useSwitchRole from '@/hooks/use-switch-role';
import { APP_ROUTES } from '@/lib/routes/app-routes';

export default function Layout() {
  const {
    mutate: switchRole,
    isPending: isRoleSwitching,
    variables: pendingRole,
  } = useSwitchRole();

  const navigate = useNavigate();

  const { isTabSwitching, shouldRedirect, isBottomNavVisible, isQsActive, showLoader } =
    useRoleAccess({
      isRoleSwitching,
      pendingRole,
    });

  const onSwitchRole = useCallback(
    (role: string, onSettled?: () => void) => {
      switchRole(role, { onSettled });
    },
    [switchRole]
  );

  const shouldNavigate = !isRoleSwitching && shouldRedirect;

  useEffect(() => {
    if (!shouldNavigate) {
      return;
    }

    navigate(isQsActive ? APP_ROUTES.archive : APP_ROUTES.dashboard, { replace: true });
  }, [shouldNavigate, isQsActive, navigate]);

  return (
    <Sheet>
      <div className="bg-train-bg flex h-screen w-full flex-1 flex-col">
        <TopNav
          onSwitchRole={onSwitchRole}
          isRoleSwitching={isRoleSwitching}
          isTabSwitching={isTabSwitching}
        />
        <Sidepanel />
        <main className="flex-1 overflow-hidden">{showLoader ? <PageLoader /> : <Outlet />}</main>
        {isBottomNavVisible && (
          <BottomNav onSwitchRole={onSwitchRole} isRoleSwitching={isRoleSwitching} />
        )}
      </div>
    </Sheet>
  );
}
